var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('app-breadcrumb',{attrs:{"page-title":'Parent Profile',"icon":'user'}}),_vm._v(" "),_c('app-lead-parent-profile-card',{attrs:{"parentId":_vm.id}}),_vm._v(" "),(
			_vm.personalInfoPropsData ||
			_vm.childrenInfoPropsData ||
			_vm.financePropsData ||
			_vm.passwordChangePropsData ||
			_vm.socialLinksPropsData
		)?_c('div',[_c('app-tab',{attrs:{"tabs":_vm.computedTabs,"icon":'user'}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }